import {VisualizarLaudoService} from './visualizar-laudo.service';
import {
  VisualizarLaudoRespostaModel,
  ItensLaudoVistoriaProcessoImagemOuVideoStorage
} from './visualizar-laudo-resposta.model';
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {Router, UrlTree} from '@angular/router';
import {Title} from '@angular/platform-browser';
import { PopUpService } from 'app/compartilhado/componentes/pop-up/pop-up.service';
import { RequestsService } from 'app/compartilhado/servicos/requests.service';
import { GlobalService } from 'app/compartilhado/servicos/global.service';

@Component({
  selector: 'app-visualizar-laudo',
  templateUrl: './visualizar-laudo.component.html',
  styleUrls: ['./visualizar-laudo.component.scss', '../../../styles-tab.scss']
})

export class VisualizarLaudoComponent implements OnInit, OnDestroy {
  @ViewChild('popup', {static: true}) popup: ElementRef;
  subsLaudoChanged: Subscription;
  subsFotosVeiculoChanged: Subscription;
  subscriptionLocal: Subscription;
  subsPdf: Subscription;
  laudo = new VisualizarLaudoRespostaModel();
  interessadoDivVisible: boolean;
  exibirDivFotosVistoriador = true;
  exibirDivDadosVistoriaMovel = true;
  processoImagem: ItensLaudoVistoriaProcessoImagemOuVideoStorage[] = [];
  shortGuid = '';
  laudoNumero = '';

  constructor(private titleService: Title, public service: VisualizarLaudoService, private requestsService: RequestsService,
              private popUpService: PopUpService, private router: Router, private globalService: GlobalService) {

    this.titleService.setTitle('Otimiza Laudos');

    // Inicializa as subscriptions
    this.subsPdf = this.requestsService.anexoDocumentoChanged.subscribe(resposta => {
      this.globalService.nativeWindow.open(resposta);
    });

    this.subsLaudoChanged = this.service.laudoChanged.subscribe((laudo) => {
      this.laudo = laudo;
      this.processoImagem = this.laudo.LaudoVistoriaProcessoImagemStorage;
      this.laudo.LaudoVistoriaProcessoImagemStorage = [];

      for (let i = 0; i < this.processoImagem.length; i++) {
        if (this.processoImagem[i].ImagemLocalizacaoTipo !== 'VI' && this.processoImagem[i].ImagemLocalizacaoTipo !== 'VT')
          this.laudo.LaudoVistoriaProcessoImagemStorage.push(this.processoImagem[i]);
      }

      if (laudo.TipoVistoria !== 'Vistoria Móvel')
        this.exibirDivFotosVistoriador = !!(laudo.CaminhoFotoVistoriadorInicio !== '' || laudo.CaminhoFotoVistoriadorTermino);
      if (laudo.EmpresaUf === 'ES')
        this.interessadoDivVisible = true;
    });

    this.subsFotosVeiculoChanged = this.service.fotosVeiculosChanged.subscribe((resposta) => {
      if (resposta)
        this.service.carregando = false;
    });

    this.subscriptionLocal = this.service.localChanged.subscribe(resposta => {
      window.open('https://www.google.com/maps?q=' + resposta.Latitude + ',' + resposta.Longitude, '_blank');
    });

    // Efetua a requisição das informações a partir dos parâmetros informados na rota
    const tree: UrlTree = this.router.parseUrl(this.router.url);

    this.shortGuid = tree.queryParams.key;
    this.laudoNumero = tree.queryParams.laudo;

    this.laudo.LaudoVistoriaProcessoImagemStorage = [];
    this.laudo.LaudoVistoriaProcessoVideoStorage = [];
    this.laudo.HistoricoTentativaEmissao = [];
    this.laudo.LaudoVistoriaCondicaoList = [];
    this.laudo.LaudoRetificacaoLista = [];

    if (this.shortGuid && this.laudoNumero) {
      const verificaEstado = +this.laudoNumero.substring(0, 2);
      const estado = this.laudoNumero.substring(0, 2);
      if (((estado !== 'SP' && estado !== 'LG' && estado !== 'ES' && estado !== 'MT' && estado !== 'MS') || verificaEstado) && this.laudoNumero.search('-') < 0 || this.laudoNumero.search('-') > 0 && !this.laudoNumero.split('-')[1]) {
        this.popUpService.showCustomPopWarning('Atenção!', 'O número de Laudo inserido está com o formado incorreto.');
        return;
      }
    }
    this.service.obterLaudo(this.shortGuid, this.laudoNumero);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subsLaudoChanged.unsubscribe();
    this.subsPdf.unsubscribe();
    this.subsFotosVeiculoChanged.unsubscribe();
    this.subscriptionLocal.unsubscribe();
  }

  onVisualizarImagemOriginal(id) {
    if (id){
      const url = this.router.createUrlTree(['/imagemoriginal'], { queryParams: { LaudoVistoria: id, key: this.shortGuid } }).toString();
      window.open(url, '_blank');
    }
  }

  onVisualizarVideos() {
    if (this.shortGuid && this.laudoNumero && this.service.laudoVistoriaId && this.laudo.LaudoNumero) {
      if (this.laudoNumero.search('/'))
        this.laudoNumero = this.laudoNumero.replace('/', '&');
      const url = this.router.createUrlTree(['/videos'], { queryParams: { LaudoNumero: this.laudoNumero, key: this.shortGuid } }).toString();
      window.open(url, '_blank');
    }
  }

  onVisualizarPdf() {
    if (this.shortGuid && this.laudoNumero && this.service.dadosAdicionaisLaudo)
      this.requestsService.visualizarDocumentoPDF(this.service.dadosAdicionaisLaudo);
  }
}
